// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LogoImage_wrapper_NHfTj","icon":"LogoImage_icon_3w5-l"};